module.exports = __webpack_public_path__ + "static/beamcolumnjoint.076ad955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/bcj/beamcolumnjoint.png
// module id = 183
// module chunks = 189712120597197 266278358803734